module.exports = __webpack_public_path__ + "static/media/QRPlay.8523a0ca.jpg";